import { lazy } from 'react'

export const SmartAi = lazy(() => import('./SmartAi'))
